import util from './util.js'
//v1.0.0

//const pre_url = "http://127.0.0.1:8989";
//const pre_url = "http://192.168.4.186:8989"
const pre_url = "http://192.168.2.4:8989";
//const pre_url = "http://192.168.11.13:8989";

async function getAllUsers(){
  try{
    let url = pre_url+"/getAllUsers";
    return await util.request(url);
  }catch(err){}
}

async function getDepartMentList(){
	try{
		let url = pre_url + "/getDepartMentList";
    return await util.request(url);
	} catch(e) {
		//console.log(e);
		throw e.message;
	}
}

async function getUserList(department_id,department_ids){
	let url = pre_url + "/getUserSimplelist";
	// let result = await util.request(url,params,'POST');
	// return result;
	let userIdList = [];
	let userList = [];
	if(department_id == 1){
		let funs = [];
		department_ids.map((item,index) => {
			if(item.id != 1){
				funs.push(new Promise(async (res,rej) => {
					try{
						let result = await util.request(url,{'department_id': item.id});
						res(result);
					}catch(e){
						throw e.message;
					}
				}))
			}
		})
		return Promise.all(funs).then(data => {
			let dataLen = data.length;
			for(let i = 0; i < dataLen; i++){
				userList = userList.concat(data[i]);
			}
			userIdList = userList.map((item,index) => {
				return item.userid
			})
			//console.log(userList,userIdList);
			return {userList,userIdList};
		})
	} else {
		try{
			let r = await util.request(url,{department_id});
			userIdList = r.map((item,index) => {
			return item.userid
			});
			return {'userList': r,userIdList};
		}catch(e){
			throw e.message;
		}
	}
}

async function getCheckInMonthData(params){
	let url = pre_url + "/getCheckInMonthData";
	let result = await util.request(url,params,'POST');
	return result;
}

async function getCheckInDayData(params){
	console.log('获取打卡信息');
  	let url = pre_url + "/getCheckInDayData";
  	let result = await util.request(url,params,'POST');
  	return result;
}

async function getCheckInData(starttime,endtime,monthDays,departmentid){
	let url = pre_url + "/getCheckInData";
	let params = {
  		starttime,
		endtime,
		monthDays,
		departmentid
  	}
  	try{
  		let reuslt = util.request(url,params,'POST');
		return reuslt;
  	}catch(e){
  		console.log(e);
  	}
}

async function getCheckInDataNF(starttime,endtime,monthDays,departmentid){
	let url = pre_url + "/getCheckInDataNF";
	let params = {
  		starttime,
		endtime,
		monthDays,
		departmentid
  	}
	try{
  		let reuslt = util.request(url,params,'POST');
		return reuslt;
  	}catch(e){
  		console.log(e);
  	}
}

function getApprovalInfo(departmentid,starttime,endtime,monthDays){
	let url = pre_url + "/getApprovalInfo";
	let params = {
		departmentid,
  		starttime,
		endtime,
		monthDays
  	}
  	return new Promise((resolve,reject) => {
  		util.request(url,params,'POST').then( _data => {
	      resolve(_data);
	    }, rej => {
	      reject();
	    }).catch(e =>{})
  	})
}

async function getOverWorkData(departmentid,starttime,endtime,monthDays){
  	let url = pre_url + "/getOverWorkData";
  	let params = {
		departmentid,
  		starttime,
		endtime,
		monthDays
  	}
  	let result = await util.request(url,params,'POST');
  	return result;
}

async function sendNotice(){
  	let url = pre_url + "/sendNotice";
  	let params = {

  	}
  	let result = await util.request(url,params,'POST');
  	return result;
}

export default {
	getUserList,
	getCheckInMonthData,
	getCheckInDayData,
	getCheckInData,
	getCheckInDataNF,
	getApprovalInfo,
	getDepartMentList,
	getOverWorkData,
  getAllUsers,
  sendNotice
}



//////////////////
// WEBPACK FOOTER
// ./static/requiredata.js
// module id = null
// module chunks = 